import { Routes } from '@angular/router';

export const CONNECTOR_TYPES_ROUTES: Routes = [
  {
    path: 'connector-types',
    loadComponent: () =>
      import('./connector-types-list/connector-types-list.component')
        .then(m => m.ConnectorTypesListComponent),
  }
];
